import React from "react";
import cn from "classnames";
import styles from "./Avatar.module.sass";

/** Iniciales y degradado estables por nombre/email (salen de Subscriptions). */
export const initials = (name = "") =>
  name
    .split(/[\s@._-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0]?.toUpperCase())
    .join("") || "?";

const GRADS = [
  ["#FFBC99", "#FF8A65"],
  ["#CABDFF", "#8E59FF"],
  ["#B1E5FC", "#2A85FF"],
  ["#B5E4CA", "#83BF6E"],
  ["#FFD88D", "#FFB020"],
  ["#FFA5D8", "#FF6AC2"],
];

export const gradFor = (str = "") => {
  let h = 0;
  for (const c of str) h = (h * 31 + c.charCodeAt(0)) & 0xffffffff;
  const [a, b] = GRADS[Math.abs(h) % GRADS.length];
  return `linear-gradient(135deg, ${a}, ${b})`;
};

/** `user = { name?, email?, avatarUrl? }`; `label` sustituye al nombre (p. ej. un alias). */
const Avatar = ({ user, label: forcedLabel, size }) => {
  const label = forcedLabel || user?.name || user?.email || "?";
  return (
    <div className={cn(styles.avatar, { [styles.avatarLg]: size === "lg" })} style={{ background: gradFor(label) }}>
      {user?.avatarUrl ? <img src={user.avatarUrl} alt="" /> : <span>{initials(label)}</span>}
    </div>
  );
};

export default Avatar;
